import { InjectionToken } from '@angular/core';
import { CmsModuleConfig } from '@domgen/dgx-fe-content-management';

export const CMS_CONFIG = new InjectionToken<CmsModuleConfig>(
  'CMS Config Per Deployment Environment'
);
